import axios from 'axios';
// Inited in packages/fe/appointment-booking/src/core/utils/sagas.ts
export var jrniAPI = axios.create();
